import infoBlackIcon from 'assets/image/icons/tables/info-black.svg'
import clsx from 'clsx'
import { FullLoader } from 'components/atoms/FullLoader/FullLoader'
import { executionsApi } from 'features/executions'
import { Dropdown } from 'semantic-ui-react'
import { useSwitcher } from 'shared/hooks'

import TooltipCustom from '../../atoms/tooltipCustom'

export function Details({ isUpward, item }: { isUpward?: boolean; item: any }) {
	const switcher = useSwitcher()

	const { currentData, isFetching } = executionsApi.useStepMessageQuery(
		{
			execution: item.campaignExecutionId,
			step: item.stepNumber
		},
		{
			skip: !switcher.isOn
		}
	)

	return (
		<Dropdown
			className={clsx(
				'btn-drop',
				item.actions.show_details.enabled ? 'btn-accent' : 'btn-row disabled'
			)}
			direction='left'
			icon={
				<TooltipCustom
					arrow={true}
					isVisible={!switcher.isOn}
					title={item.actions.show_details.hint || ''}
				>
					<img alt='infoBlackIcon' className='icon' src={infoBlackIcon} />
				</TooltipCustom>
			}
			onClose={switcher.off}
			onOpen={() => item.actions.show_details.enabled && switcher.on()}
			upward={isUpward}
		>
			<Dropdown.Menu
				className={clsx(
					'activity-info',
					isUpward ? 'position-top' : 'position-bottom'
				)}
			>
				<Dropdown.Item>
					<div className='drop-down-container'>
						<span className='drop-down-container__label'>
							Action #{item.indexAction}:
						</span>
						<h5 className='headline'>{item.header}</h5>
						<div className='drop-down-container__description'>
							<div className='text-wrapper'>
								<div className='text-dropdown-p'>
									{isFetching && <FullLoader size={18} />}
									{currentData && (
										<pre className='word-break'>{currentData}</pre>
									)}
								</div>
							</div>
						</div>
					</div>
				</Dropdown.Item>
			</Dropdown.Menu>
		</Dropdown>
	)
}
